import { render, staticRenderFns } from "./AegCaseProposalList.vue?vue&type=template&id=73a4907a"
import script from "./AegCaseProposalList.vue?vue&type=script&lang=js"
export * from "./AegCaseProposalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports